import { match } from 'ts-pattern'
import type { ValueOf } from 'type-fest'
import { DecorationType } from '~/services/apollo/generated/graphql'

export const ProfilePageTab = {
  artworks: 'artworks',
  likes: 'likes',
  tasks: 'tasks',
  credits: 'credits',
  theme: 'theme',
  models: 'models',
  bookmarkedModels: 'bookmarked-models',
  manga: 'manga',
  likedManga: 'liked-manga',
  /** @deprecated */
  likedSdv1Model: 'liked-sdv1-model',
  likedModel: 'liked-model',
  /** @deprecated */
  likedLoraModel: 'liked-lora-model',
  likedLora: 'liked-lora',
  bookmarks: 'favorites',
  files: 'files',
  workflows: 'workflows',
  decorations: 'decorations',
  assets: 'assets',
} as const

export const enum FollowType {
  follower = 'follower',
  following = 'following',
}

export const ALL_FOLLOW_TYPES = [
  FollowType.follower,
  FollowType.following,
] as const

export const DecorationPageTab = {
  Badge: 'badge',
  AvatarFrame: 'avatar-frame',
  CollectionCard: 'collection-card',
  ArtworkFrame: 'artwork-frame',
  LiveBanner: 'live-banner',
} as const
export type DecorationPageTab = ValueOf<typeof DecorationPageTab>

export function mapDecorationTypeToProfilePageTab(type: DecorationType) {
  return (
    match(type)
      .returnType<DecorationPageTab>()
      .with(DecorationType.Badge, () => DecorationPageTab.Badge)
      .with(DecorationType.AvatarFrame, () => DecorationPageTab.AvatarFrame)
      .with(DecorationType.ArtworkFrame, () => DecorationPageTab.ArtworkFrame)
      .with(DecorationType.LiveBanner, () => DecorationPageTab.LiveBanner)
      // Fallback to avoid crashing with unexpected values
      .otherwise(() => DecorationPageTab.Badge)
  )
}
